parasails.registerPage('pride', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    isLoading: true,
    errorMessage: '',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function () {
    //…
  },
  mounted: async function () {
    if (!this.urlslug) {
      this.isLoading = false;
      this.errorMessage = 'Could not find voting session ID. Please scan the QR code again.';
      return;
    }

    // 2. Get the persistent device ID from our utility function.
    const deviceId = await this.getOrSetDeviceId();
    if (!deviceId) {
      this.isLoading = false;
      this.errorMessage = 'Could not identify your device. Please ensure cookies are enabled.';
      return;
    }

    // 3. Make a SINGLE API call to our powerful validate-vote action.
    try {
      await io.socket.post('/validate-vote', {
        urlslug: this.urlslug,
        deviceId: deviceId
      }, (resData, jwres) => {
        if (resData && resData.status === 'error') {

          if (resData.message === 'already-voted-today' && resData.originalSlug) {
            console.log('User already voted today. Redirecting to original slug:', resData.originalSlug);
            window.location.href = `/housepride/vote/${resData.originalSlug}`;
            return;
          }
        }

        // Check the HTTP status code from the server's response.
        if (jwres.statusCode !== 200) {
          // The server rejected the validation. Display the error and redirect.
          window.location.href = `/housepride/vote/${this.urlslug}`;
          return;
        }

        // 4. SUCCESS: The server responded with 200 OK. Redirect to the vote page.
        window.location.href = `/housepride/vote/${this.urlslug}`;
      });
    } catch (err) {
      // This catches network errors (e.g., user is offline).
      this.errorMessage = '位置情報をオンにして、エリア内からアクセスしてください';
      console.error('Network error during validation:', err);
    }
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    getOrSetDeviceId: async function () {
      const STORAGE_KEY = 'housepride_deviceId';
      let deviceId = null;

      // 1. Try to get the ID from localStorage first.
      try {
        deviceId = localStorage.getItem(STORAGE_KEY);
        if (deviceId) {
          // Ensure the cookie is also set, in case it was cleared.
          document.cookie = `${STORAGE_KEY}=${deviceId}; path=/; max-age=31536000`; // 1 year
          return deviceId;
        }
      } catch (e) {
        console.warn('localStorage is not available.');
      }

      // 2. If not in localStorage, try to get it from the cookie.
      const cookieMatch = document.cookie.match(new RegExp(`(^| )${STORAGE_KEY}=([^;]+)`));
      if (cookieMatch) {
        deviceId = cookieMatch[2];
        // Sync it back to localStorage for faster access next time.
        try {
          localStorage.setItem(STORAGE_KEY, deviceId);
        } catch (e) { /* localStorage not available */ }
        return deviceId;
      }

      // 3. If it exists in neither, generate a new one.
      // We'll use a simple but effective random string generator.
      // This avoids needing a full library like nanoid on the client.
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        deviceId = result.visitorId; // This is the fingerprint hash (e.g., a4b1b3f2a8f8b1b3)
      } catch (error) {
        console.log("using fallback for deviceId");
        deviceId = 'hp_' + Date.now().toString(36) + Math.random().toString(36).substring(2);
      }

      // 4. Save the new ID to both localStorage and the cookie.
      try {
        localStorage.setItem(STORAGE_KEY, deviceId);
      } catch (e) { /* localStorage not available */ }
      document.cookie = `${STORAGE_KEY}=${deviceId}; path=/; max-age=31536000`; // 1 year

      return deviceId;
    }
  }
});
